import moment from 'moment-timezone';
import 'moment/locale/fr-ca.js';

export default moment;
